import { FilterProject } from '@shared/api/filters-ws';
import { SminexClubWsClient } from '@shared/api/sminex-club-clients-ws';
import { resolveProjectLabel } from '../filterAndSortSminexClubClients';
import { Client } from '../../model/types';

export const mapWsClientsToClients = (
  wsClients: SminexClubWsClient[],
  projectCatalog: FilterProject[] = []
): Client[] =>
  wsClients.map((wsClient, index) => {
    const invitingManager = wsClient.ticket.invitedByManager ?? wsClient.manager ?? '';

    return {
      id: wsClient.ticket.id || index + 1,
      rowKey: `${wsClient.ticket.id}:${wsClient.crmUuid}:${index}`,
      participantId: wsClient.participantId ?? (wsClient.ticket.id || index + 1),
      crmUuid: wsClient.crmUuid || null,
      firstName: wsClient.firstName,
      lastName: wsClient.lastName,
      surname: wsClient.surname,
      phone: '',
      doNotCall: wsClient.callRefusal,
      age: null,
      countChildren: null,
      photoUrl: null,
      maritalStatus: null,
      brokerName: wsClient.broker,
      notes: null,
      manager: wsClient.manager
        ? {
            id: '',
            participantId: '',
            firstName: wsClient.manager,
            lastName: '',
            surname: '',
            active: true,
          }
        : null,
      projects: wsClient.projects.length
        ? wsClient.projects.map((token) => {
            const resolved = resolveProjectLabel(token, projectCatalog);
            return { project: { id: resolved.id, name: resolved.name } };
          })
        : null,
      events: null,
      isSpecial: wsClient.isSpecial,
      ticket: {
        id: wsClient.ticket.id,
        checked: wsClient.ticket.checked,
        invitationStatus: '',
        sminexClubInvitation: wsClient.ticket.sminexClubInvitation,
        sminexClubReconfirmationStatus: wsClient.ticket.sminexClubReconfirmationStatus,
        review: wsClient.ticket.review,
        sminexClubAdditional: wsClient.ticket.sminexClubAdditional || [],
        mobileComment: wsClient.ticket.mobileComment || '',
        organizerName: invitingManager || wsClient.ticket.organizerName,
        comment: wsClient.ticket.comment,
      },
    };
  });
